var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.391,
    height: 6.954,
    viewBox: "0 0 11.391 6.954",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Component_47_3",
    "data-name": "Component 47 \\u2013 3",
    transform: "translate(.696 .718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Union_16",
    fill: "rgba(0,0,0,0)",
    stroke: "#4e4e57",
    strokeWidth: "2px",
    d: "M4.844 5L0 0l4.844 5L5 4.839 4.844 5 5 5.161 4.844 5 0 10z",
    "data-name": "Union 16",
    transform: "rotate(90 5 5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.10edd842b04cb0b0d2a954a88842b8b7.svg";
export { ForwardRef as ReactComponent };